import React from "react";

export default function Footer() {
  return (
    <footer className="pt-16 pb-10 border-t border-stone-900/15" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5">
          <p className="font-serif italic text-3xl md:text-4xl leading-none">Books for Little Hands</p>
          <p className="mt-3 text-[11px] uppercase tracking-[0.3em] text-stone-500">
            A small imprint · Big-hearted books
          </p>
          <p className="mt-6 text-stone-700 max-w-md">
            Series № 01: <em>Finance for Little Hands</em>. Illustrated storybooks with hands-on activities that build early financial literacy in children.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <p className="folio-num">Navigate</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="#series" className="hover:text-stone-500 transition-colors">The Series</a></li>
            <li><a href="#books" className="hover:text-stone-500 transition-colors">Books</a></li>
            <li><a href="#maya" className="hover:text-stone-500 transition-colors">Meet Maya</a></li>
            <li><a href="#testimonials" className="hover:text-stone-500 transition-colors">Reviews</a></li>
            <li><a href="#author" className="hover:text-stone-500 transition-colors">Creators</a></li>
            <li><a href="#newsletter" className="hover:text-stone-500 transition-colors">Newsletter</a></li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-4">
          <p className="folio-num">Correspondence</p>
          <ul className="mt-4 space-y-2 text-sm text-stone-700">
            <li>littlehandsbookseries@gmail.com</li>
            <li>School &amp; library enquiries welcome</li>
            <li>Bulk orders — write to us</li>
          </ul>
          <p className="folio-num mt-8">Follow</p>
          <a
            href="https://www.instagram.com/books.for.little.hands/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex items-center gap-3 group"
            data-testid="footer-instagram-link"
          >
            <span className="inline-flex items-center justify-center w-9 h-9 border border-stone-900/25 rounded-full transition-colors duration-300 group-hover:bg-stone-900 group-hover:text-[color:var(--paper)]">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </span>
            <span className="text-sm underline-offset-4 group-hover:underline">@books.for.little.hands</span>
          </a>
        </div>

        <div className="col-span-12 hairline pt-6 flex flex-wrap items-center justify-between text-[11px] uppercase tracking-[0.28em] text-stone-500">
          <span>© {new Date().getFullYear()} Books for Little Hands</span>
          <span>Printed with care · Made for slow evenings</span>
          <span>№ 001 — 005</span>
        </div>
      </div>
    </footer>
  );
}
